"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateCompany = class CreateCompany extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    role;
    onRole(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("role");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    messages;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateCompany', {
            emails: null,
            role: this.role,
            relation: this.role === 'company' ? 'na' : 'customer'
        });
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['messages', 'item', 'formName', 'formId', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    create: {
                        own: this.$fn.pgettext("Company|Header", "New own company"),
                        partner: this.$fn.pgettext("Company|Header", "New partner"),
                    },
                    resourceTitle: {
                        own: this.$fn.pgettext("Company|ResourceTitle", "Company"),
                        partner: this.$fn.pgettext("Company|ResourceTitle", "Partner"),
                    },
                    submitButtonText: {
                        own: this.$fn.pgettext("Button", "Create company"),
                        partner: this.$fn.pgettext("Button", "Create partner"),
                    },
                },
                item: null,
                formName: "company",
                formId: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.resourceTitle[this.role];
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.messages.create[this.role],
                icon: this.$config.company.icons[this.role],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3684_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_3690_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_3692_getActionArgs($event) {
        return {
            location: {
                name: "app.company",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_3694_getActionArgs($event) {
        return {
            grid: "companies",
        };
    }
    async act_1040167445267876_request_3688_getActionArgs($event) {
        return {
            operation: "create_company",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_setData_3696_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5534025912102772_input(event, scope) {
        return await this.actions.evh_5534025912102772_input.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3684 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3684_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3683 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3684,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3683],
        });
        const act_2248226175642056_closeModal_3686 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3685 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3686,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3685],
        });
        const act_1040167445267876_closeComponent_3690 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_3690_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3689 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_3690,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_3692 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_3692_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3691 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_3692,
            event: "success",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_3694 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_3694_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3693 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_3694,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_request_3688 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_3688_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_success_3689, evh_1040167445267876_success_3691, evh_1040167445267876_success_3693],
        });
        const evh_1040167445267876_submit_3687 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_3688,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3687],
        });
        const act_5534025912102772_setData_3696 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5534025912102772_setData_3696_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_input_3695 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_setData_3696,
            event: "input",
            displayName: "setData",
        });
        const evh_5534025912102772_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_input_3695],
        });
        const act_1419464017721962_closeComponent_3698 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3697 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_3698,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3697],
        });
        return {
            act_7315092382398562_closeModal_3684,
            evh_7315092382398562_close_3683,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3686,
            evh_2248226175642056_close_3685,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_3690,
            evh_1040167445267876_success_3689,
            act_1040167445267876_navigate_3692,
            evh_1040167445267876_success_3691,
            act_1040167445267876_reloadSlickgrid_3694,
            evh_1040167445267876_success_3693,
            act_1040167445267876_request_3688,
            evh_1040167445267876_submit_3687,
            evh_1040167445267876_submit,
            act_5534025912102772_setData_3696,
            evh_5534025912102772_input_3695,
            evh_5534025912102772_input,
            act_1419464017721962_closeComponent_3698,
            evh_1419464017721962_clickPreventStop_3697,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_request_3688,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], CreateCompany.prototype, "role", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('role'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateCompany.prototype, "onRole", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], CreateCompany.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateCompany.prototype, "onSize", null);
CreateCompany = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateCompany);
exports.default = CreateCompany;
vue_property_decorator_1.Vue.component("CreateCompany", CreateCompany);
